export default __webpack_public_path__ + "0ae73baaad04bc5923a4d7d149b29468.svg";